// extracted by mini-css-extract-plugin
export default {"EstimatedFare":"EstimateFareManagementPage_EstimatedFare__ecBlk"};